module.exports = __webpack_public_path__ + "static/media/ic-category-list-off.e7a70453.svg";